import {useIsSoftFeatureToggleActive} from '@aboutyou/feature-flags';
import {lazy} from '@aboutyou/lazy-imports';
import {useIsConsentBannerAccepted} from '@aboutyou/storage';
import {doAsync, useOS} from '@aboutyou/utils';
import React, {useEffect, useState} from 'react';

const SessionSharing = () => {
  const [startSessionSharing, setStartSessionSharing] = useState(false);
  const isSessionSharingEnabled = useIsSoftFeatureToggleActive(
    'tadarida_session_sharing',
  );
  const isIos = useOS() === 'ios';
  const isConsentBannerAccepted = useIsConsentBannerAccepted();

  useEffect(() => {
    // Session sharing won't work in ios due to the privacy policy of ios chrome and safari
    // cross domain local storage does not work in safari hence the feature is disabled in safari and chrome
    if (isSessionSharingEnabled && isConsentBannerAccepted && !isIos) {
      doAsync(() => {
        // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
        setStartSessionSharing(true);
      });
    }
  }, [isSessionSharingEnabled, isIos, isConsentBannerAccepted]);

  return startSessionSharing ? <SessionSharingLazy /> : null;
};

const SessionSharingLazy = lazy(() =>
  import('./SessionSharing').then(mod => ({
    default: mod.SessionSharing,
  })),
);

export {SessionSharing};
